// extracted by mini-css-extract-plugin
module.exports = {"supportAlert":"BrowserSupportAlert_supportAlert__Jnxg3"};